import React from "react";
import { IDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { DataTypePicker } from "../DataTypePicker/DataTypePicker";
import { ObserveState } from "../StateManagement/ObserveState";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { SxProps } from "@mui/material";
import { StringDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { getPropertyEditorValidationIssues, PropertyEditorValidationTooltip } from "./PropertyEditorValidationTooltip";

export interface PropertyEditorTypeSelectionInterface {
    editObject: object;
    propertyName: string;
    label?: string;
    hint?: string;
    onChange?: () => void;
    sx?: SxProps;
    sxInput?: SxProps;
    error?: string;
    ignoreDesignerValidation?: boolean;
}

export const PropertyEditorTypeSelection: React.FC<PropertyEditorTypeSelectionInterface> = (
    props: PropertyEditorTypeSelectionInterface,
) => {
    return (
        <ObserveState
            listenTo={props.editObject}
            properties={[props.propertyName]}
            control={() => {
                const type = Reflect.get(props.editObject, props.propertyName) as IDataDefinition;

                let validationIssues = getPropertyEditorValidationIssues(
                    props.editObject,
                    props.propertyName,
                    props.error,
                );

                return (
                    <PropertyEditorValidationTooltip
                        editObject={props.editObject}
                        propertyName={props.propertyName}
                        error={validationIssues}
                    >
                        <DataTypePicker
                            dataDef={type || new StringDataDefinition()}
                            label={props.label}
                            hint={props.hint}
                            error={validationIssues?.message}
                            sx={{ width: "100%", ...props.sx }}
                            sxInput={props.sxInput}
                            updateCallback={(newtype: IDataDefinition) => {
                                Reflect.set(props.editObject, props.propertyName, newtype);
                                StateManager.propertyChanged(props.editObject, props.propertyName);
                                if (props.onChange) props.onChange();
                            }}
                        />
                    </PropertyEditorValidationTooltip>
                );
            }}
        />
    );
};
